export class GameStatus {
  constructor(ind, skunkId, name) {
    this.ind = ind;
    this.skunkId = skunkId;
    this.name = name;
  }
}
